<!-- contract -->
<template>
  <div class="apply-contract">
    <Form
      ref="formValidate"
      v-if="type === 'SMCM'"
      :model="formValidate"
      :rules="ruleValidate"
    >
      <div class="apply-contract-item">
        <div>
          <h1>Detail info</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Linkedin (N/A,if you don’t have Linkedin)"
              prop="baseInfo.linkedin"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.baseInfo.linkedin"
                placeholder="e.g. linkedin.com/in/johnsmith"
              ></Input>
            </FormItem>
            <!-- <FormItem label="Skype ID"
                      :label-width="560">
              <Input v-model.trim="formValidate.baseInfo.skypeId"
                     placeholder=""></Input>
            </FormItem> -->
            <FormItem
              label="Local time zone"
              prop="businessInfo.zone"
              :label-width="560"
            >
              <Select
                v-model="formValidate.businessInfo.zone"
                placeholder="select time zone"
              >
                <Option
                  v-for="item in zone"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.title }}</Option
                >
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form">
            <FormItem
              label="Are you a native English speaker?"
              prop="baseInfo.englishSpeaker"
              :label-width="560"
            >
              <Select
                v-model="formValidate.baseInfo.englishSpeaker"
                placeholder="select yes or no"
              >
                <Option value="1">YES</Option>
                <Option value="0">NO</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Can you speak Chinese？"
              prop="baseInfo.chineseSpeaker"
              :label-width="560"
            >
              <Select
                v-model="formValidate.baseInfo.chineseSpeaker"
                placeholder="select yes or no"
              >
                <Option value="1">YES</Option>
                <Option value="0">NO</Option>
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form">
            <FormItem
              label="Class"
              prop="eduInfo.graduation"
              :label-width="560"
            >
              <Select
                v-model="formValidate.eduInfo.graduation"
                placeholder="Year of receiving the current/ most recent degree (e.g. 2019)"
              >
                <Option v-for="item in 21" :value="2004 + item" :key="item">{{
                  2004 + item
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Main specific research area"
              prop="eduInfo.mainResearch"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.mainResearch"
                placeholder="e.g. Integrated Circuit, N/A if not applicable"
              ></Input>
            </FormItem>
            <FormItem
              label="Undergraduate university"
              prop="eduInfo.benkeUniver"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.benkeUniver"
                placeholder="e.g.  Oxford"
              ></Input>
            </FormItem>
            <FormItem
              label="Undergraduate degree and field of study"
              prop="eduInfo.benkeField"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.benkeField"
                placeholder="e.g.  BA Economics"
              ></Input>
            </FormItem>
            <FormItem
              label="Other educational degrees / experiences"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.otherEduExp"
                placeholder="e.g. other degreed/ non-degreed programs, N/A if not applicable"
              ></Input>
            </FormItem>
            <FormItem
              label="Current position"
              prop="otherInfo.occupation"
              :label-width="560"
            >
              <Select
                v-model="formValidate.otherInfo.occupation"
                placeholder="please select"
              >
                <Option
                  v-for="item in occupation"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.title }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              label="Please specify"
              prop="otherInfo.employer"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.otherInfo.employer"
                placeholder="e.g.  N/A if student / Goldman Sachs "
              ></Input>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Personal Info</h1>
          <div class="apply-contract-form">
            <FormItem
              label="ID Type"
              prop="contractBasicInfo.idType"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.idType"
                placeholder="select one"
              >
                <Option value="IDCard">ID Card</Option>
                <Option value="StateID">State ID</Option>
                <Option value="Passport">Passport</Option>
                <Option value="Driver">Driver's licenses</Option>
                <Option value="Other">Other</Option>
              </Select>
            </FormItem>
            <FormItem
              label="ID Number"
              prop="contractBasicInfo.idNum"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.contractBasicInfo.idNum"
                placeholder=""
              ></Input>
            </FormItem>
            <FormItem
              label="Phone (Emergency use only) "
              prop="contractBasicInfo.phone"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.contractBasicInfo.phone"
                placeholder="e.g. +86 13512345678"
              ></Input>
            </FormItem>
            <FormItem
              label="Current living country"
              prop="contractBasicInfo.country"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.country"
                placeholder="select your country"
                filterable
                clearable
                @on-change="selectCountryModel"
              >
                <Option
                  v-for="item in selectCountryList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="Current living state"
              prop="contractBasicInfo.province"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.province"
                clearable
                @on-change="selectProvinceModel"
                placeholder="select your state"
              >
                <Option
                  v-for="item in selectProvinceList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="Current living city"
              prop="contractBasicInfo.city"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.city"
                placeholder="select your city"
              >
                <Option
                  v-for="item in selectCityList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
            <div style="margin-top:40px;">
              <div
                v-for="(item, index) in formValidate.contractBasicInfo
                  .freeTimeInfos"
                :key="index"
              >
                <FormItem
                  :label="`My preferred time for appointments 0${index + 1}`"
                  :prop="`contractBasicInfo.freeTimeInfos.${index}.week`"
                  :label-width="560"
                  :rules="[{ required: true, message: promptSelect }]"
                >
                  <Select v-model="item.week" placeholder="select day of week">
                    <Option
                      v-for="(weekItem, index) in week"
                      :value="index + 1"
                      :key="index"
                      >{{ weekItem }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem
                  label="Time"
                  :prop="`contractBasicInfo.freeTimeInfos.${index}.time.0`"
                  :label-width="560"
                  :rules="[{ required: true, message: promptSelect }]"
                >
                  <TimePicker
                    type="timerange"
                    placeholder="Select time"
                    style="width:100%;"
                    format="HH:mm"
                    v-model="item.time"
                  ></TimePicker>
                </FormItem>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Personal Files</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Document of proof for attended university"
              :label-width="560"
              prop="contractBasicInfo.studentId"
            >
              <Input
                v-model="formValidate.contractBasicInfo.studentId"
                style="display:none;"
              ></Input>
              <div v-show="studentName">
                <span class="cv-name">{{ studentName }}</span>
                <Icon
                  type="ios-close-circle"
                  size="16"
                  class="del-cv"
                  @click="delStudenthandle"
                />
              </div>
              <span
                class="apply-contract-upload"
                @click="uploadHandle('studentModal')"
                v-show="!studentName"
              >
                Upload
              </span>
              <p class="contract-warn">
                E.g. pic of student id, offer letter email screenshot, diploma,
                transcripts, or other documents of proof
              </p>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Payment</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Chinese citizen"
              prop="chineseCitizen"
              :label-width="560"
            >
              <RadioGroup v-model="formValidate.chineseCitizen">
                <Radio :label="1"> <span class="w92">Yes</span></Radio>
                <Radio :label="0"> <span class="w92">No</span></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Payment method" prop="payWay" :label-width="560">
              <RadioGroup
                v-model="formValidate.payWay"
                @on-change="payWayHandle"
              >
                <Radio label="PAYPAL"><span class="w92">Paypal</span></Radio>
                <Radio label="INLAND"
                  ><span class="w92">云账户（人民币）</span></Radio
                >
              </RadioGroup>
              <a
                href="javascript:void(0);"
                class="account-link"
                @click="descModal = true"
                >什么是云账户？</a
              >
            </FormItem>
            <!-- 选择云账户 -->
            <template v-if="formValidate.payWay === 'INLAND'">
              <div key="1">
                <FormItem
                  label="收款人姓名"
                  prop="contractInlandInfo.payeeName"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.payeeName"
                    placeholder="e.g. 张三"
                  ></Input>
                </FormItem>
                <FormItem
                  label="银行卡号"
                  prop="contractInlandInfo.cardNumber"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.cardNumber"
                    placeholder="e.g. 612345000000001234"
                  ></Input>
                </FormItem>
                <FormItem
                  label="手机号"
                  prop="contractInlandInfo.payeePhone"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.payeePhone"
                    placeholder="e.g. 13512345678"
                  ></Input>
                </FormItem>
                <FormItem
                  label="国籍"
                  prop="contractInlandInfo.nationality"
                  :label-width="560"
                >
                  <RadioGroup
                    v-model="formValidate.contractInlandInfo.nationality"
                    @on-change="nationalityHandle"
                  >
                    <Radio label="NATIONAL"
                      ><span class="w92">大陆籍</span></Radio
                    >
                    <Radio label="UNNATIONAL"
                      ><span class="w92">非大陆籍</span></Radio
                    >
                  </RadioGroup>
                </FormItem>
                <!-- 选择大陆籍 -->
                <template
                  v-if="
                    formValidate.contractInlandInfo.nationality === 'NATIONAL'
                  "
                >
                  <div key="2">
                    <FormItem
                      label="身份证号"
                      prop="contractInlandInfo.payeeIdCard"
                      :label-width="560"
                    >
                      <Input
                        v-model.trim="
                          formValidate.contractInlandInfo.payeeIdCard
                        "
                        placeholder="e.g. 100000199001011234"
                      ></Input>
                    </FormItem>
                  </div>
                </template>
                <!-- 选择非大陆籍 -->
                <template
                  v-if="
                    formValidate.contractInlandInfo.nationality === 'UNNATIONAL'
                  "
                >
                  <div :key="3">
                    <FormItem
                      label="证件类型"
                      prop="contractInlandInfo.payeeIdType"
                      :label-width="560"
                    >
                      <RadioGroup
                        v-model="formValidate.contractInlandInfo.payeeIdType"
                      >
                        <Radio label="PASSPORT"
                          ><span class="w92">护照号</span></Radio
                        >
                        <Radio label="PASSAGE"
                          ><span class="w92"
                            >港澳台来往内地通行证号</span
                          ></Radio
                        >
                      </RadioGroup>
                    </FormItem>
                    <FormItem
                      label="证件号码"
                      prop="contractInlandInfo.payeeIdCard"
                      :label-width="560"
                    >
                      <Input
                        v-model.trim="
                          formValidate.contractInlandInfo.payeeIdCard
                        "
                        placeholder="e.g. 100000199001011234"
                      ></Input>
                    </FormItem>
                    <FormItem label="证件截图" :label-width="560">
                      <!--  prop="contractInlandInfo.screenshot" -->
                      <Input
                        v-model="formValidate.contractInlandInfo.screenshot"
                        style="display:none;"
                      ></Input>
                      <span
                        class="apply-contract-upload"
                        @click="uploadHandle('screenshotsModal')"
                        v-show="!screenshotName"
                      >
                        Upload
                      </span>
                      <div v-show="screenshotName">
                        <span class="cv-name">{{ screenshotName }}</span>
                        <Icon
                          type="ios-close-circle"
                          size="16"
                          class="del-cv"
                          @click="delScreenshothandle"
                        />
                      </div>
                    </FormItem>
                  </div>
                </template>
              </div>
            </template>
            <!-- 选择Paypal -->
            <template v-if="formValidate.payWay === 'PAYPAL'">
              <div :key="4">
                <FormItem
                  label="Payment method"
                  prop="contractPaypalInfo.currency"
                  :label-width="560"
                >
                  <RadioGroup
                    v-model="formValidate.contractPaypalInfo.currency"
                  >
                    <Radio label="USD"><span class="w92">USD</span></Radio>
                    <Radio label="GBP"><span class="w92">GBP</span></Radio>
                    <Radio label="HKD"><span class="w92">HKD</span></Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem
                  label="PayPal"
                  prop="contractPaypalInfo.payPalEmail"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractPaypalInfo.payPalEmail"
                    placeholder="you@domain.com"
                  ></Input>
                </FormItem>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="apply-contract-item apply-detail-item-simple">
        <div>
          <h1 style="padding-left:0;">
            The information below will help us market you and introduce you to
            your potential mentee(s). The more detailed your interesting facts
            are, the more likely potential mentees will choose you to be their
            mentor.
          </h1>
          <div class="apply-contract-form" style="padding-right:0;">
            <div class="apply-contract-title">
              We really want to showcase your amazing achievements and talents
              to inspire and further motivate our mentees, for whom you will be
              a role model!<br /><br />Achievements, unique experiences, and
              interests (up to 7)
            </div>
            <div style="margin:20px 0;color:#ffa940">
              Please list at least 3, up to 7
            </div>
            <FormItem
              v-for="(item, index) in formValidate.otherInfo.facts"
              :key="index"
            >
              <Input
                v-model.trim="formValidate.otherInfo.facts[index]"
                :placeholder="otherInfoPlaceholder[index]"
              ></Input>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form" style="padding-right:0;">
            <div class="apply-detail-title dis-24">
              Please list all graduate programs that you got admitted to / got
              offers from ( if applicable )<br />
              (including all programs you didn't end up attending; both Master's
              and PhD as relevant)
            </div>
            <Input
              v-model="formValidate.otherInfo.allGraduate"
              placeholder="e.g.  N/A if student / Goldman Sachs "
              type="textarea"
              :rows="6"
            ></Input>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Contract</h1>
          <div class="apply-contract-content contract-content">
            <!-- 合同内容 -->
            <template v-if="isLook">
              <pdf-preview :url="curData.url"></pdf-preview>
            </template>
            <!-- <contract-content></contract-content> -->
            <iframe :src="curData.url"
              frameborder="0" width="980" height="640"></iframe>
          </div>
          <div class="apply-contract-agree">
            <Checkbox v-model="isArgee"
              >I have read, understood and agree to the ZLR Valeon School/Career
              Mentor Agreement v1.2</Checkbox
            >
            <div class="apply-contract-agree-prompt">
              我已经阅读，理解并同意北京再来人华来荣信息技术有限公司（再来人Valeon）顾问咨询服务协议
              v1.2
            </div>
          </div>
          <div class="apply-contract-sign">
            <p>Type in your full name below to digitally sign the agreement</p>
            <div class="apply-contract-form">
              <FormItem
                label="Digital Signature 电子签署"
                prop="contractSign.signFullName"
                :label-width="560"
              >
                <Input
                  v-model.trim="formValidate.contractSign.signFullName"
                  placeholder="Type in full name"
                ></Input>
              </FormItem>
              <FormItem
                label="Date of Agreement 签署日期"
                prop="name"
                :label-width="560"
              >
                {{ formValidate.contractSign.subSignDate }}
              </FormItem>
              <FormItem
                label="ZLR Valeon Legal Representative Name:"
                prop="name"
                :label-width="560"
                class="remove-style"
              >
                Xuansha Chen
              </FormItem>
              <FormItem
                label="北京再来人华来荣信息技术有限公司法定代表人姓名"
                prop="name"
                :label-width="560"
              >
                谌烜沙
              </FormItem>
              <FormItem
                label="ZLR Valeon Company Seal"
                prop="name"
                :label-width="560"
                class="remove-style"
              >
              </FormItem>
              <FormItem
                label="北京再来人华来荣信息技术有限公司公章:"
                prop="name"
                :label-width="560"
              >
              </FormItem>
              <img :src="Charter" alt="再来人章" class="contract-charter" />
            </div>
          </div>
          <div class="apply-contract-wel">
            By clicking submit, you confirm that you agree to the ZLR Valeon
            School/Career Mentor Agreement v1.2, as detailed above.<br />
            点击提交，即确认你同意北京再来人华来荣信息技术有限公司（再来人Valeon）顾问咨询服务协议
            v1.2所列的所有条款。<br /><br />
            Thank you! We look forward to working with you!<br />
            谢谢！期待与你一同工作！
          </div>
          <div class="apply-contract-btn">
            <Button class="zlr-btn-default" @click="backHandle">Back</Button>
            <Button
              class="zlr-btn-primary"
              :disabled="!isArgee"
              @click="subHandle"
              :loading="isSub"
              >Submit</Button
            >
          </div>
        </div>
      </div>
    </Form>
    <Form
      ref="formValidate"
      v-if="type === 'EM'"
      :model="formValidate"
      :rules="ruleValidate"
    >
      <div class="apply-contract-item">
        <div>
          <h1>Detail info</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Linkedin (N/A,if you don’t have Linkedin)"
              prop="baseInfo.linkedin"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.baseInfo.linkedin"
                placeholder="e.g. linkedin.com/in/johnsmith"
              ></Input>
            </FormItem>
            <!-- <FormItem label="Skype ID"
                      :label-width="560">
              <Input v-model.trim="formValidate.baseInfo.skypeId"
                     placeholder=""></Input>
            </FormItem> -->
            <FormItem
              label="Local time zone"
              prop="businessInfo.zone"
              :label-width="560"
            >
              <Select
                v-model="formValidate.businessInfo.zone"
                placeholder="select time zone"
              >
                <Option
                  v-for="item in zone"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.title }}</Option
                >
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form">
            <FormItem
              label="Are you a native English speaker?"
              prop="baseInfo.englishSpeaker"
              :label-width="560"
            >
              <Select
                v-model="formValidate.baseInfo.englishSpeaker"
                placeholder="select yes or no"
              >
                <Option value="1">YES</Option>
                <Option value="0">NO</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Can you speak Chinese？"
              prop="baseInfo.chineseSpeaker"
              :label-width="560"
            >
              <Select
                v-model="formValidate.baseInfo.chineseSpeaker"
                placeholder="select yes or no"
              >
                <Option value="1">YES</Option>
                <Option value="0">NO</Option>
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form">
            <FormItem
              label="Class"
              prop="eduInfo.graduation"
              :label-width="560"
            >
              <Select
                v-model="formValidate.eduInfo.graduation"
                placeholder="Year of receiving the current/ most recent degree (e.g. 2019)"
              >
                <Option v-for="item in 21" :value="2004 + item" :key="item">{{
                  2004 + item
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Main specific research area"
              prop="eduInfo.mainResearch"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.mainResearch"
                placeholder="e.g. Integrated Circuit, N/A if not applicable"
              ></Input>
            </FormItem>
            <FormItem
              label="Undergraduate university"
              prop="eduInfo.benkeUniver"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.benkeUniver"
                placeholder="e.g.  Oxford"
              ></Input>
            </FormItem>
            <FormItem
              label="Undergraduate degree and field of study"
              prop="eduInfo.benkeField"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.benkeField"
                placeholder="e.g.  BA Economics"
              ></Input>
            </FormItem>
            <FormItem
              label="Other educational degrees / experiences"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.eduInfo.otherEduExp"
                placeholder="e.g. other degreed/ non-degreed programs, N/A if not applicable"
              ></Input>
            </FormItem>
            <FormItem
              label="Current position"
              prop="otherInfo.occupation"
              :label-width="560"
            >
              <Select
                v-model="formValidate.otherInfo.occupation"
                placeholder="please select"
              >
                <Option
                  v-for="item in occupation"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.title }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              label="Please specify"
              prop="otherInfo.employer"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.otherInfo.employer"
                placeholder="e.g.  N/A if student / Goldman Sachs "
              ></Input>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Personal Info</h1>
          <div class="apply-contract-form">
            <FormItem
              label="ID Type"
              prop="contractBasicInfo.idType"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.idType"
                placeholder="select one"
              >
                <Option value="IDCard">ID Card</Option>
                <Option value="StateID">State ID</Option>
                <Option value="Passport">Passport</Option>
                <Option value="Driver">Driver's licenses</Option>
                <Option value="Other">Other</Option>
              </Select>
            </FormItem>
            <FormItem
              label="ID Number"
              prop="contractBasicInfo.idNum"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.contractBasicInfo.idNum"
                placeholder=""
              ></Input>
            </FormItem>
            <FormItem
              label="Phone (Emergency use only) "
              prop="contractBasicInfo.phone"
              :label-width="560"
            >
              <Input
                v-model.trim="formValidate.contractBasicInfo.phone"
                placeholder="e.g. +86 13512345678"
              ></Input>
            </FormItem>
            <FormItem
              label="Current living country"
              prop="contractBasicInfo.country"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.country"
                placeholder="select your country"
                filterable
                clearable
                @on-change="selectCountryModel"
              >
                <Option
                  v-for="item in selectCountryList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="Current living state"
              prop="contractBasicInfo.province"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.province"
                clearable
                @on-change="selectProvinceModel"
                placeholder="select your state"
              >
                <Option
                  v-for="item in selectProvinceList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="Current living city"
              prop="contractBasicInfo.city"
              :label-width="560"
            >
              <Select
                v-model="formValidate.contractBasicInfo.city"
                placeholder="select your city"
              >
                <Option
                  v-for="item in selectCityList"
                  :value="item.name"
                  :key="item.name"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Personal Files</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Document of proof for attended university"
              :label-width="560"
              prop="contractBasicInfo.studentId"
            >
              <Input
                v-model="formValidate.contractBasicInfo.studentId"
                style="display:none;"
              ></Input>
              <div v-show="studentName">
                <span class="cv-name">{{ studentName }}</span>
                <Icon
                  type="ios-close-circle"
                  size="16"
                  class="del-cv"
                  @click="delStudenthandle"
                />
              </div>
              <span
                class="apply-contract-upload"
                @click="uploadHandle('studentModal')"
                v-show="!studentName"
              >
                Upload
              </span>
              <p class="contract-warn">
                E.g. pic of student id, offer letter email screenshot, diploma,
                transcripts, or other documents of proof
              </p>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Payment</h1>
          <div class="apply-contract-form">
            <FormItem
              label="Chinese citizen"
              prop="chineseCitizen"
              :label-width="560"
            >
              <RadioGroup v-model="formValidate.chineseCitizen">
                <Radio :label="1"> <span class="w92">Yes</span></Radio>
                <Radio :label="0"> <span class="w92">No</span></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Payment method" prop="payWay" :label-width="560">
              <RadioGroup
                v-model="formValidate.payWay"
                @on-change="payWayHandle"
              >
                <Radio label="PAYPAL"><span class="w92">Paypal</span></Radio>
                <Radio label="INLAND"
                  ><span class="w92">云账户（人民币）</span></Radio
                >
              </RadioGroup>
              <a
                href="javascript:void(0);"
                class="account-link"
                @click="descModal = true"
                >什么是云账户？</a
              >
            </FormItem>
            <!-- 选择云账户 -->
            <template v-if="formValidate.payWay === 'INLAND'">
              <div key="1">
                <FormItem
                  label="收款人姓名"
                  prop="contractInlandInfo.payeeName"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.payeeName"
                    placeholder="e.g. 张三"
                  ></Input>
                </FormItem>
                <FormItem
                  label="银行卡号"
                  prop="contractInlandInfo.cardNumber"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.cardNumber"
                    placeholder="e.g. 612345000000001234"
                  ></Input>
                </FormItem>
                <FormItem
                  label="手机号"
                  prop="contractInlandInfo.payeePhone"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractInlandInfo.payeePhone"
                    placeholder="e.g. 13512345678"
                  ></Input>
                </FormItem>
                <FormItem
                  label="国籍"
                  prop="contractInlandInfo.nationality"
                  :label-width="560"
                >
                  <RadioGroup
                    v-model="formValidate.contractInlandInfo.nationality"
                    @on-change="nationalityHandle"
                  >
                    <Radio label="NATIONAL"
                      ><span class="w92">大陆籍</span></Radio
                    >
                    <Radio label="UNNATIONAL"
                      ><span class="w92">非大陆籍</span></Radio
                    >
                  </RadioGroup>
                </FormItem>
                <!-- 选择大陆籍 -->
                <template
                  v-if="
                    formValidate.contractInlandInfo.nationality === 'NATIONAL'
                  "
                >
                  <div key="2">
                    <FormItem
                      label="身份证号"
                      prop="contractInlandInfo.payeeIdCard"
                      :label-width="560"
                    >
                      <Input
                        v-model.trim="
                          formValidate.contractInlandInfo.payeeIdCard
                        "
                        placeholder="e.g. 100000199001011234"
                      ></Input>
                    </FormItem>
                  </div>
                </template>
                <!-- 选择非大陆籍 -->
                <template
                  v-if="
                    formValidate.contractInlandInfo.nationality === 'UNNATIONAL'
                  "
                >
                  <div :key="3">
                    <FormItem
                      label="证件类型"
                      prop="contractInlandInfo.payeeIdType"
                      :label-width="560"
                    >
                      <RadioGroup
                        v-model="formValidate.contractInlandInfo.payeeIdType"
                      >
                        <Radio label="PASSPORT"
                          ><span class="w92">护照号</span></Radio
                        >
                        <Radio label="PASSAGE"
                          ><span class="w92"
                            >港澳台来往内地通行证号</span
                          ></Radio
                        >
                      </RadioGroup>
                    </FormItem>
                    <FormItem
                      label="证件号码"
                      prop="contractInlandInfo.payeeIdCard"
                      :label-width="560"
                    >
                      <Input
                        v-model.trim="
                          formValidate.contractInlandInfo.payeeIdCard
                        "
                        placeholder="e.g. 100000199001011234"
                      ></Input>
                    </FormItem>
                    <FormItem
                      label="证件截图"
                      prop="contractInlandInfo.screenshot"
                      :label-width="560"
                    >
                      <Input
                        v-model="formValidate.contractInlandInfo.screenshot"
                        style="display:none;"
                      ></Input>
                      <span
                        class="apply-contract-upload"
                        @click="uploadHandle('screenshotsModal')"
                        v-show="!screenshotName"
                      >
                        Upload
                      </span>
                      <div v-show="screenshotName">
                        <span class="cv-name">{{ screenshotName }}</span>
                        <Icon
                          type="ios-close-circle"
                          size="16"
                          class="del-cv"
                          @click="delScreenshothandle"
                        />
                      </div>
                    </FormItem>
                  </div>
                </template>
              </div>
            </template>
            <!-- 选择Paypal -->
            <template v-if="formValidate.payWay === 'PAYPAL'">
              <div :key="4">
                <FormItem
                  label="Payment method"
                  prop="contractPaypalInfo.currency"
                  :label-width="560"
                >
                  <RadioGroup
                    v-model="formValidate.contractPaypalInfo.currency"
                  >
                    <Radio label="USD"><span class="w92">USD</span></Radio>
                    <Radio label="GBP"><span class="w92">GBP</span></Radio>
                    <Radio label="HKD"><span class="w92">HKD</span></Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem
                  label="PayPal"
                  prop="contractPaypalInfo.payPalEmail"
                  :label-width="560"
                >
                  <Input
                    v-model.trim="formValidate.contractPaypalInfo.payPalEmail"
                    placeholder="you@domain.com"
                  ></Input>
                </FormItem>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="apply-contract-item apply-detail-item-simple">
        <div>
          <h1 style="padding-left:0;">
            The information below will help us market you and introduce you to
            your potential mentee(s). The more detailed your interesting facts
            are, the more likely potential mentees will choose you to be their
            mentor.
          </h1>
          <div class="apply-contract-form" style="padding-right:0;">
            <div class="apply-contract-title">
              We really want to showcase your amazing achievements and talents
              to inspire and further motivate our mentees, for whom you will be
              a role model!<br /><br />Achievements, unique experiences, and
              interests (up to 7)
            </div>
            <div style="margin:20px 0;color:#ffa940">
              Please list at least 3, up to 7
            </div>
            <FormItem
              v-for="(item, index) in formValidate.otherInfo.facts"
              :key="index"
            >
              <Input
                v-model.trim="formValidate.otherInfo.facts[index]"
                :placeholder="otherInfoPlaceholder[index]"
              ></Input>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <div class="apply-contract-form" style="padding-right:0;">
            <div class="apply-detail-title dis-24">
              Please list all graduate programs that you got admitted to / got
              offers from ( if applicable )<br />
              (including all programs you didn't end up attending; both Master's
              and PhD as relevant)
            </div>
            <Input
              v-model="formValidate.otherInfo.allGraduate"
              placeholder="e.g.  N/A if student / Goldman Sachs "
              type="textarea"
              :rows="6"
            ></Input>
          </div>
        </div>
      </div>
      <div class="apply-contract-item">
        <div>
          <h1>Contract</h1>
          <div class="apply-contract-content contract-content">
            <!-- 合同内容 -->
            <template v-if="isLook">
              <pdf-preview :url="curData.url"></pdf-preview>
            </template>
            <!-- <contract-content></contract-content> -->
          </div>
          <div class="apply-contract-agree">
            <Checkbox v-model="isArgee"
              >I have read, understood and agree to the ZLR Valeon School/Career
              Mentor Agreement v1.2</Checkbox
            >
            <div class="apply-contract-agree-prompt">
              我已经阅读，理解并同意北京再来人华来荣信息技术有限公司（再来人Valeon）顾问咨询服务协议
              v1.2
            </div>
          </div>
          <div class="apply-contract-sign">
            <p>Type in your full name below to digitally sign the agreement</p>
            <div class="apply-contract-form">
              <FormItem
                label="Digital Signature 电子签署"
                prop="contractSign.signFullName"
                :label-width="560"
              >
                <Input
                  v-model.trim="formValidate.contractSign.signFullName"
                  placeholder="Type in full name"
                ></Input>
              </FormItem>
              <FormItem
                label="Date of Agreement 签署日期"
                prop="name"
                :label-width="560"
              >
                {{ formValidate.contractSign.subSignDate }}
              </FormItem>
              <FormItem
                label="ZLR Valeon Legal Representative Name:"
                prop="name"
                :label-width="560"
                class="remove-style"
              >
                Xuansha Chen
              </FormItem>
              <FormItem
                label="北京再来人华来荣信息技术有限公司法定代表人姓名"
                prop="name"
                :label-width="560"
              >
                谌烜沙
              </FormItem>
              <FormItem
                label="ZLR Valeon Company Seal"
                prop="name"
                :label-width="560"
                class="remove-style"
              >
              </FormItem>
              <FormItem
                label="北京再来人华来荣信息技术有限公司公章:"
                prop="name"
                :label-width="560"
              >
              </FormItem>
              <img :src="Charter" alt="再来人章" class="contract-charter" />
            </div>
          </div>
          <div class="apply-contract-wel">
            By clicking submit, you confirm that you agree to the ZLR Valeon
            School/Career Mentor Agreement v1.2, as detailed above.<br />
            点击提交，即确认你同意北京再来人华来荣信息技术有限公司（再来人Valeon）顾问咨询服务协议
            v1.2所列的所有条款。<br /><br />
            Thank you! We look forward to working with you!<br />
            谢谢！期待与你一同工作！
          </div>
          <div class="apply-contract-btn">
            <Button class="zlr-btn-default" @click="backHandle">Back</Button>
            <Button
              class="zlr-btn-primary"
              :disabled="!isArgee"
              @click="subHandle"
              :loading="isSub"
              >Submit</Button
            >
          </div>
        </div>
      </div>
    </Form>
    <apply-upload
      v-model="studentModal"
      ref="studentModal"
      :path="`studentcard/${new Date().getTime()}`"
      @up-success="studentSucHandle"
    ></apply-upload>
    <apply-upload
      v-model="screenshotsModal"
      ref="screenshotsModal"
      path="passport"
      @up-success="screenshotSucHandle"
    ></apply-upload>
    <zlr-modal v-model="descModal">
      <div class="apply-contract-desc">
        <ul>
          <li v-for="(item, index) in emDesc.content" :key="index">
            <h2>{{ item.title }}</h2>
            <div v-html="item.detail">
              {{ item.detail }}
            </div>
          </li>
        </ul>
        <div class="apply-contract-desc-btn">
          <Button class="zlr-btn-default" @click="descModal = false"
            >Close</Button
          >
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
import dayjs from 'dayjs'
// api
import { applyMentorContract } from '@/api/apply'
import {
  getAreaCountryEn,
  getAreaProvinceEn,
  getAreaCityEn
} from '@/libs/area/area'
// components
import ApplyUpload from './upload'
import ZlrModal from '_c/modal/modal'
import PdfPreview from '@/components/pdf-preview/index'

// img
import Charter from '@/assets/images/home/contract-charter.png'
// constant
import { promptInput, promptSelect, week } from '@/constant'
import { zone, occupation, referrerSource } from '@/constant/mentor'
// mixins
import back from './back'
import { mapMutations } from 'vuex'

import _ from 'lodash'
export default {
  name: 'apply-em-contract',
  props: ['value', 'type'],
  mixins: [back],
  components: {
    ApplyUpload,
    ZlrModal,
    PdfPreview
  },
  data () {
    return {
      week,
      zone,
      occupation,
      referrerSource,
      promptSelect,
      otherInfoPlaceholder: [
        'e.g. Rhodes Scholar',
        'e.g. Declined full scholarship to Harvard to cofound ZLR Valeon',
        'e.g. Engaged with policy makers in setting up a sovereign wealth fund'
      ],
      studentModal: false,
      screenshotsModal: false,
      formValidate: {
        applyId: this.value,
        contractBasicInfo: {
          freeTimeInfos: [{}, {}]
        },
        contractPaypalInfo: {},
        contractInlandInfo: {},
        contractSign: {
          subSignDate: dayjs().format('YYYY-MM-DD')
        },
        payWay: 'PAYPAL',
        businessInfo: {},
        baseInfo: {
          linkedin: 'https://www.linkedin.com/in/'
        },
        eduInfo: {},
        otherInfo: {
          facts: ['', '', '', '', '', '', '']
        }
      },
      ruleValidate: {
        'baseInfo.linkedin': [{ required: true, message: promptInput }],
        'businessInfo.zone': [{ required: true, message: promptSelect }],
        'baseInfo.englishSpeaker': [{ required: true, message: promptSelect }],
        'baseInfo.chineseSpeaker': [{ required: true, message: promptSelect }],
        'eduInfo.graduation': [{ required: true, message: promptSelect }],
        'eduInfo.mainResearch': [{ required: true, message: promptInput }],
        'eduInfo.benkeUniver': [{ required: true, message: promptInput }],
        'eduInfo.benkeField': [{ required: true, message: promptInput }],
        'otherInfo.occupation': [{ required: true, message: promptInput }],
        'otherInfo.employer': [{ required: true, message: promptInput }],
        'otherInfo.hearByType': [{ required: true, message: promptSelect }],
        'otherInfo.hearBy': [{ required: true, message: promptInput }],
        'contractBasicInfo.idType': [{ required: true, message: promptSelect }],
        'contractBasicInfo.idNum': [{ required: true, message: promptInput }],
        'contractBasicInfo.phone': [{ required: true, message: promptInput }],
        'contractBasicInfo.country': [
          { required: true, message: promptSelect }
        ],
        'contractBasicInfo.province': [
          { required: true, message: promptSelect }
        ],
        'contractBasicInfo.city': [{ required: true, message: promptSelect }],
        'contractBasicInfo.studentId': [
          {
            required: true,
            message:
              'Required, but if unable to upload, please send to mentorhelp@zlrvaleon.com'
          }
        ],
        chineseCitizen: [{ required: true, message: promptSelect }],
        payWay: [{ required: true, message: promptSelect }],
        'contractPaypalInfo.payPalEmail': [
          { required: true, message: promptInput }
        ],
        'contractPaypalInfo.currency': [
          { required: true, message: promptSelect }
        ],
        'contractInlandInfo.payeeName': [
          { required: true, message: promptInput }
        ],
        'contractInlandInfo.cardNumber': [
          { required: true, message: promptInput }
        ],
        'contractInlandInfo.payeePhone': [
          { required: true, message: promptInput }
        ],
        'contractInlandInfo.nationality': [
          { required: true, message: promptSelect }
        ],
        'contractInlandInfo.payeeIdType': [
          { required: true, message: promptSelect }
        ],
        'contractInlandInfo.payeeIdCard': [
          { required: true, message: promptSelect }
        ],
        // 'contractInlandInfo.screenshot': [{ required: true, message: promptSelect }],
        'contractSign.signFullName': [{ required: true, message: promptInput }]
      },
      selectCountryList: [],
      selectProvinceList: [],
      selectCityList: [],
      initPaypal: {
        contractPaypalInfo: {}
      },
      isArgee: true,
      Charter,
      screenshotName: '',
      studentName: '',
      isSub: false,
      descModal: false,
      emDesc: {
        content: [
          {
            title: '云账户',
            detail: `云账户为再来人目前使用人民币支付的唯一途径。云账户是个自由职业者个人所得税代征平台，服务共享经济平台和自由职业者两端。云账户与税务机关签署《委托代征协议》以技术手段辅助国家和税务机关建立以自然人为纳税人的征税体系。可以为企业提供服务费发票，为提供服务的个人进行完税和付款。目前和云账户合作的知名企业包括火山抖音，华谊保险，今日头条，京东到家，链家等。如何注册云账户等详细信息可在签约后，登入MSP平台，进入Material页面查看)`
          }
        ]
      },
      curData: {
        url: 'https://res.zailairen.com/msp/docs/mentor/agreement.pdf'
      },
      // 支付方式对应的合同url
      payWayMap: {
        'EM': {
          'PAYPAL': 'https://res.zailairen.com/msp/docs/mentor/agreement.pdf',
          'INLAND': 'https://res.zailairen.com/msp/docs/mentor/agreement.pdf'
        },
        'SMCM': {
          'PAYPAL': 'https://res.zailairen.com/msp/docs/mentor/agreement.pdf',
          'INLAND': 'https://res.zailairen.com/msp/docs/mentor/agreement.pdf'
        }
      },
      isLook: false
    }
  },
  computed: {},
  mounted () {
    // 国家
    this.selectCountryList = getAreaCountryEn()
    this.lookPdf = setTimeout(() => {
      this.curData.url = this.payWayMap[this.type][this.formValidate.payWay]
      this.sureLookPdf()
    }, 1000)
  },
  methods: {
    ...mapMutations(['setPaymentInfo']),
    sureLookPdf () {
      this.isLook = true
    },
    // 提交数据
    subHandle () {
      this.$refs['formValidate'].validate(valid => {
        if (valid) {
          this.isSub = true
          let data = JSON.parse(JSON.stringify(this.formValidate))
          data.otherInfo.facts = data.otherInfo.facts.filter(item => !!item)
          if (this.type === 'SMCM') {
            data.contractBasicInfo.freeTimeInfos[0].time = data.contractBasicInfo.freeTimeInfos[0].time.join(
              '-'
            )
            data.contractBasicInfo.freeTimeInfos[1].time = data.contractBasicInfo.freeTimeInfos[1].time.join(
              '-'
            )
          }
          applyMentorContract(data)
            .then(res => {
              this.$zlr_message('Successful application', 'success')
              this.setPaymentInfo(true)
              this.$emit('on-success')
              // 下边手动控制跳转apply-waiting页面，不需要了
              // let setTime = setTimeout(() => {
              //   this.$router.push({
              //     name: 'apply-waiting',
              //     params: {
              //       type: `${this.type}-waiting`
              //     }
              //   })
              //   clearTimeout(setTime)
              // }, 2500)
            })
            .catch(error => {
              this.$zlr_message(error.message, 'error')
            })
            .then(() => {
              this.isSub = false
            })
        } else {
          this.$zlr_message(promptInput, 'error')
        }
      })
    },
    uploadHandle (name) {
      this.$refs[name].showHandle()
    },
    // 切换payWay
    payWayHandle (val) {
      // 初始化数据
      if (val === 'PAYPAL') {
        this.$set(this.formValidate, 'payeeName', '')
        this.$set(this.formValidate, 'contractInlandInfo', {})
      } else {
        this.$set(this.formValidate, 'contractPaypalInfo', {})
      }
      // 重新获取合同路径
      this.curData.url = this.payWayMap[this.type][this.formValidate.payWay]
    },
    // 切换国籍
    nationalityHandle (val) {
      // 初始化数据
      if (val === 'NATIONAL') {
        this.$set(this.formValidate.contractInlandInfo, 'payeeIdType', '')
        this.$set(this.formValidate.contractInlandInfo, 'payeeIdCard', '')
        this.$set(this.formValidate.contractInlandInfo, 'screenshot', '')
      } else {
        this.$set(this.formValidate, 'contractPaypalInfo', {})
      }
      // 初始化护照
      this.delScreenshothandle()
    },
    // 国家
    selectCountryModel (countryCode) {
      this.selectProvinceList = getAreaProvinceEn(countryCode)
      this.$set(this.formValidate.contractBasicInfo, 'city', '')
      this.$set(this.formValidate.contractBasicInfo, 'province', '')
      this.selectCityList = []
    },
    // 省
    selectProvinceModel (provinceCode) {
      this.$set(this.formValidate.contractBasicInfo, 'city', '')
      let countryCode = this.formValidate.contractBasicInfo.country
      if (!(provinceCode && countryCode)) {
        return false
      }
      this.selectCityList = getAreaCityEn(countryCode, provinceCode)
    },
    // 学生照
    studentSucHandle (data) {
      this.$set(this.formValidate.contractBasicInfo, 'studentId', data.path)
      this.studentName = data.name
    },
    // 删除学生照
    delStudenthandle () {
      this.studentSucHandle({
        path: '',
        name: ''
      })
    },
    // 护照
    screenshotSucHandle (data) {
      this.$set(this.formValidate.contractInlandInfo, 'screenshot', data.path)
      this.screenshotName = data.name
    },
    // 删除护照
    delScreenshothandle () {
      this.screenshotSucHandle({
        path: '',
        name: ''
      })
    }
  },
  watch: {
    value (newValue) {
      this.$set(this.formValidate, 'applyId', newValue)
    }
  }
}
</script>
<style lang="less" scoped>
.contract-content {
  height: 640px;
  overflow-y: auto;
}
</style>
